"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normaliseCIN = exports.validateCIN = exports.parseCIN = exports.normalise = exports.validate = exports.parse = void 0;
var corporateIdentityNumber_1 = require("./corporateIdentityNumber");
var personalNumber_1 = require("./personalNumber");
var types_1 = require("./types");
function parse(input, options) {
    if (!options) {
        options = {};
    }
    if (options.forgiving === undefined) {
        options.forgiving = true;
    }
    if (options.strict === undefined) {
        options.strict = true;
    }
    if (options.normaliseFormat === undefined) {
        options.normaliseFormat = "YYYYMMDDNNNN";
    }
    return (0, personalNumber_1.parse)(input, options);
}
exports.parse = parse;
function validate(input, options) {
    if (!options) {
        options = {};
    }
    if (options.forgiving === undefined) {
        options.forgiving = true;
    }
    if (options.strict === undefined) {
        options.strict = true;
    }
    return parse(input, options).valid;
}
exports.validate = validate;
function normalise(input, options) {
    if (!options) {
        options = {};
    }
    if (options.forgiving === undefined) {
        options.forgiving = true;
    }
    if (options.strict === undefined) {
        options.strict = true;
    }
    if (options.normaliseFormat === undefined) {
        options.normaliseFormat = "YYYYMMDDNNNN";
    }
    var pn = parse(input, options);
    if (pn.valid) {
        return pn.normalised;
    }
    return undefined;
}
exports.normalise = normalise;
function parseCIN(input, options) {
    if (!options) {
        options = {};
    }
    var cin = (0, corporateIdentityNumber_1.parse)(input, options);
    var pn;
    if (cin.valid) {
        return cin;
    }
    else {
        var pnFormat = options.shortNormalisation ? "YYMMDD-NNNN" : "YYYYMMDDNNNN";
        pn = parse(input, { forgiving: true, strict: true, normaliseFormat: pnFormat });
    }
    if (pn.valid) {
        pn.type = types_1.PersonalNumberType.IndividualCompany; // Enskild firma
        return pn;
    }
    return cin;
}
exports.parseCIN = parseCIN;
function validateCIN(input) {
    var cin = (0, corporateIdentityNumber_1.parse)(input, {});
    var pn;
    if (cin.valid) {
        return true;
    }
    else {
        pn = parse(input, { forgiving: true, strict: true });
    }
    if (pn.valid) {
        return true;
    }
    return false;
}
exports.validateCIN = validateCIN;
function normaliseCIN(input, options) {
    if (!options) {
        options = {};
    }
    var cin = (0, corporateIdentityNumber_1.parse)(input, options);
    var pn;
    if (cin.valid) {
        return cin.normalised;
    }
    else {
        var pnFormat = options.shortNormalisation ? "YYMMDD-NNNN" : "YYYYMMDDNNNN";
        pn = parse(input, { forgiving: true, strict: true, normaliseFormat: pnFormat });
    }
    if (pn.valid) {
        return pn.normalised;
    }
    return undefined;
}
exports.normaliseCIN = normaliseCIN;
exports.default = { parse: parse, validate: validate, normalise: normalise, parseCIN: parseCIN, validateCIN: validateCIN, normaliseCIN: normaliseCIN };
__exportStar(require("./types"), exports);
